import React from "react";
import { Col, Typography } from "antd";
import "./CustomProfileSection.css";
import { ReactComponent as MobCreditBlackIcon } from "../../../assets/icons/mobcredit-direct.svg";

const MobDirectCreditCard = (props) => {
  const { Text } = Typography;
  const { primary_status, approved_balance, available_balance,is_activated } = props;
  

  // Normalize status to lowercase
  const status = (primary_status || "").toLowerCase();
  // console.log("🚀 ~ MobDirectCreditCard ~ is_activated:", is_activated)

  // Map statuses to text + classNames
  const statusMap = {
    active: {
      label: "Active",
      textClass: "text-white-default approved-text-active",
      containerClass: "mob-directcredit-container-active",
      sublabel:""
    },
    inactive: {
      label: "Account Inactive",
      textClass: "text-danger approved-text-active",
      containerClass: "mob-directcredit-container-inactive",
      sublabel:""
    },
    blocked: {
      label: "Blocked",
      textClass: "text-white-default approved-text-active",
      containerClass: "mob-directcredit-container-blocked",
      sublabel:"mobCREDIT payment due/ default"
    },
    overdue: {
      label: "Overdue",
           textClass: "text-white-default approved-text-active",
      containerClass: "mob-directcredit-container-blocked",
      sublabel:"mobCREDIT payment due/ default"
    },
    in_progress: {
      label: "In Progress",
      textClass: "text-warning approved-text-active",
      containerClass: "mob-directcredit-container-inprogress",
      sublabel:"Pre approved, incomplete or under review"
    },
  };

  // Fallback if unknown status
  let { label, textClass, containerClass,sublabel } = statusMap[status] || {
    label: "INACTIVE",
    textClass: "text-danger approved-text-active",
    containerClass: "mob-directcredit-container-inactive",
    sublabel:""
  };
if (is_activated === false) {
  ({ label, textClass, containerClass,sublabel } = statusMap["in_progress"]);
 
  
}
//  console.log("🚀 ~ MobDirectCreditCard ~ label:", label)
  return (
    <Col className={containerClass}>
  <Col className="mob-credit-icon-container">
    <Col className="d-flex-center" style={{ gap: "4px" }}>
      <MobCreditBlackIcon style={{ width: 100, height: 28 }} />
      <Text className={textClass} style={{ fontStyle: "italic" }}>Direct</Text>
    </Col>
    <Col className="d-flex" style={{ gap: "4px" }}>
     
      {["Active", "Account Inactive"].includes(label) && (<>
         <Text className={textClass}>{label}</Text>
        <Text className={textClass}> ₹ {(approved_balance || 0).toFixed(2)}</Text></>
      )}
    </Col>
  </Col>

  {["Active", "Account Inactive"].includes(label) ? (
    <Col>
      <Col className="mob-credit-available-container">
        <Text
          className={
            ["active"].includes(status)
              ? "available-heading-text-active"
              : "available-heading-text-inactive"
          }
        >
          Available balance
        </Text>
        <Text
          className={
            ["active"].includes(status)
              ? "available-text-active"
              : "available-text-inactive"
          }
        >
          ₹ {(available_balance || 0).toFixed(2)}
        </Text>
      </Col>
    </Col>
  ):(<>
  <Col>
      <Col className="mob-credit-available-container">
        <Text style={{textTransform:"uppercase",color:"#fff"}}
          className={
            ["active"].includes(status)
              ? "available-heading-text-active"
              : "available-heading-text-inactive"
          }
        >
         {label}
        </Text>
        <Text style={{fontSize:"12px",textAlign:"right",color:"#fff"}}
          className={
            ["active"].includes(status)
              ? "available-heading-text-active"
              : "available-heading-text-inactive"
          }
        >
         {sublabel}
        </Text>
      </Col>
    </Col>
  </>)}
</Col>
  );
};

export default MobDirectCreditCard;
